import { z } from "zod";

// Shape of a successful OpenAI chat completion response
const openAiResponseSchema = z.object({
  choices: z
    .array(
      z.object({
        message: z.object({
          content: z.string(),
        }),
      }),
    )
    .min(1),
});

/**
 * Validates and extracts the text content from an OpenAI chat completion response.
 * Throws a ZodError (caught by callers) on unexpected shape.
 */
export function validateOpenAiResponse(data: unknown): string {
  const parsed = openAiResponseSchema.parse(data);
  return parsed.choices[0].message.content;
}

const storyClaimSchema = z.object({
  text: z.string().min(1),
  citation_proof_id: z.string().nullable().optional(),
  is_verified: z.boolean().optional(),
});

export const candidateStoryResponseSchema = z.object({
  title: z.string().min(3),
  summary: z.string().min(10),
  markdown: z.string().min(50, {
    message: "AI-generated story is too short to be valid.",
  }),
  claims: z.array(storyClaimSchema),
});

export function parseCandidateStoryResponse(content: string) {
  return candidateStoryResponseSchema.parse(JSON.parse(content));
}
